import classNames from "classnames";
import type { HTMLInputTypeAttribute } from "react";
import type { HandleInputChange } from "./types";

type BaseInputControlProps = {
    type: HTMLInputTypeAttribute;
    name: string;
    value?: string | number;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    min?: string;
    max?: string;
    onChange: HandleInputChange;
};

const BaseInputControl = ({
    type,
    name,
    value = "",
    placeholder,
    className,
    disabled,
    min,
    max,
    onChange,
}: BaseInputControlProps) => {
    return (
        <input
            className={classNames("form-control", className)}
            type={type}
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={(event) => onChange(event, name, event.target.value)}
            disabled={disabled}
            min={min}
            max={max}
        />
    );
};

export default BaseInputControl;
